import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { LoadSitesTerminalsRequest, SearchSitesTerminalTableResponse } from "./types";

export const sitesTerminalsApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadSitesTerminals: builder.query<SearchSitesTerminalTableResponse, LoadSitesTerminalsRequest>({
            providesTags: ["mainCache"],
            query: ({ dataGroupCode, siteId }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.SITES}/${siteId}/${ResourceName.TERMINALS}`,
                method: "GET",
            }),
        }),
    }),
});

export const { useLoadSitesTerminalsQuery } = sitesTerminalsApi;
